import moment from 'moment';
import { TimeMap } from './time-data';

export const TimeUtils = {
  parseDate (stringDate) {
    const date = new Date(stringDate);
    const y = moment(date).get('year');
    const m = moment(date).get('month') + 1; // adding one to make it non-zero based months
    const d = moment(date).get('date');
    return {
      y,
      m,
      d
    };
  },
  createTimeHashFromKey (key) {
    return {
      h: TimeMap[key].h,
      m: TimeMap[key].m,
      time_index: key
    };
  },
  scheduleHash (startOrEnd, date, timeIndex) {
    const schedule = {};
    const dateHash = date ? { date: this.parseDate(date) } : {};
    const timeHash = timeIndex ? { time: this.createTimeHashFromKey(timeIndex) } : {};
    schedule[startOrEnd] = { ...dateHash, ...timeHash };
    return schedule;
  }
};
